import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth, homeFor } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { toast } from "sonner";

export function GoogleButton() {
  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      <div className="my-6 flex items-center gap-3">
        <div className="h-px flex-1 bg-[#E5E5DF]" />
        <span className="text-xs text-[#5C5C57]">or</span>
        <div className="h-px flex-1 bg-[#E5E5DF]" />
      </div>
      <Button type="button" variant="outline" onClick={googleLogin} data-testid="google-signin-btn"
        className="w-full rounded-full border-[#E5E5DF] h-11 hover:bg-[#E3DAC9]/40 transition-colors">
        <svg viewBox="0 0 24 24" className="h-4 w-4 mr-2" aria-hidden="true"><path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.1h6.5c-.1 1.1-.8 2.7-2.4 3.8l3.7 2.9c2.2-2 3.7-5 3.7-8.6z"/><path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.7-2.9c-1 .7-2.4 1.2-4.2 1.2-3.2 0-5.9-2.1-6.8-5.1l-3.9 3C3.3 21.3 7.3 24 12 24z"/><path fill="#FBBC05" d="M5.2 14.3c-.2-.7-.4-1.5-.4-2.3s.1-1.6.4-2.3l-3.9-3C.5 8.2 0 10 0 12s.5 3.8 1.3 5.3l3.9-3z"/><path fill="#EA4335" d="M12 4.7c1.8 0 3 .8 3.7 1.4l3.3-3.2C17.9 1.1 15.2 0 12 0 7.3 0 3.3 2.7 1.3 6.7l3.9 3c.9-2.9 3.6-5 6.8-5z"/></svg>
        Continue with Google
      </Button>
    </>
  );
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(homeFor(user.role));
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] noise-bg flex items-center justify-center px-6">
      <div className="card-warm w-full max-w-md p-10">
        <Link to="/" className="flex items-center gap-2 mb-8" data-testid="login-brand-link">
          <span className="h-9 w-9 rounded-full bg-[#1E3F20] flex items-center justify-center"><Leaf className="h-4 w-4 text-[#FAFAF8]" /></span>
          <span className="font-heading text-lg font-semibold tracking-tight">Assessment Center</span>
        </Link>
        <h1 className="font-heading text-3xl font-semibold tracking-tight" data-testid="login-heading">Welcome back</h1>
        <p className="text-sm text-[#5C5C57] mt-2 mb-8">Sign in to your secure portal.</p>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="login-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)} className="input-warm border-[#E5E5DF]" autoComplete="email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required data-testid="login-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)} className="input-warm border-[#E5E5DF]" autoComplete="current-password" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit-button"
            className="w-full rounded-full bg-[#1E3F20] hover:bg-[#2C5A2E] text-white h-11 transition-colors">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <GoogleButton />
        <p className="text-sm text-[#5C5C57] mt-6">
          New here? <Link to="/register" className="text-[#1E3F20] font-semibold hover:underline" data-testid="login-register-link">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
